import { Button, SelectBox, SelectBoxItem, Text, TextInput } from '@tremor/react';
import {
  FieldErrors,
  UseControllerProps,
  useFieldArray,
  UseFormRegister,
} from 'react-hook-form';
import { InvitationsSchema } from '../layouts/Modals/InviteUsersModal/InviteUsersModal';
import { permissions } from '@/types/types';

interface Props extends Pick<UseControllerProps<InvitationsSchema>, 'control'> {
  isLoading?: boolean;
  errors: FieldErrors<InvitationsSchema>;
  register: UseFormRegister<InvitationsSchema>;
  onRoleValChange: (e: string) => void;
  roleValue: string;
}

export function InviteUsersWidget({
  isLoading = false,
  control,
  register,
  errors,
  onRoleValChange,
  roleValue,
}: Props) {
  const { fields, append } = useFieldArray({
    control,
    name: 'emails',
  });

  return (
    <div className="flex flex-col items-start p-0 gap-2.5 mt-2.5 overflow-y-auto w-[400px] h-96">
      <Text className="h-5 font-arial font-normal text-sm flex items-center text-[#212121]">
        Invite People
      </Text>
      {fields.map((field, index) => (
        <TextInput
          disabled={isLoading}
          key={field.id}
          className={[
            'shadow-none h-11 bg-white border-2  text-[#425565] [&_input]:py-1.5 [&_input]:px-4 rounded-xl font-ubuntu font-normal text-lg placeholder:text-[#9e9e9e] ring-0',
            errors.emails?.[index]?.email ? '!border-red' : 'border-[#9e9e9e]',
          ].join(' ')}
          {...register(`emails.${index}.email` as const)}
          placeholder="User E-mail"
          errorMessage={errors.emails?.[index]?.email?.message}
          error={!!errors.emails?.[index]?.email}
        />
      ))}
      <Button
        disabled={isLoading}
        type="button"
        className="w-28 h-7 font-ubuntu font-bold text-base flex items-center text-[#425565] bg-transparent border-none shadow-none hover:bg-transparent"
        onClick={() => append({ email: '' })}
      >
        + Add another
      </Button>
      <Text className="h-5 font-arial font-normal text-sm flex items-center text-[#212121]">
        Choose role
      </Text>
      <SelectBox
        placeholder="Choose organization region"
        className="[&>button]:ring-0 [&>div]:overflow-auto"
        onValueChange={onRoleValChange}
        value={roleValue}
      >
        {Object.keys(permissions).map((role) => (
          <SelectBoxItem key={role} value={role} text={role.replace('_', ' ')} />
        ))}
      </SelectBox>
    </div>
  );
}
